import React, {forwardRef, useImperativeHandle} from "react";
import { useQueryClient } from 'react-query';
import __ from "lodash";

import useFindAwbAllocatedStock from "../../../services/awbStock/useAwbAllocatedStock";

const AwbAllocatedStockLookup = forwardRef((props, ref) => {

  const queryClient = useQueryClient();
  const awbPrefix = props.awbPrefix;
  const awbSerial = props.awbSerial;
  const companyUuid = props.companyUuid;
  const validateStock = props.validateStock;


  const awbAllocatedStock = useFindAwbAllocatedStock({ queryClient, extraKeys: [awbPrefix, awbSerial], useCache: false});

  useImperativeHandle(ref, () => ({
    getAwbAllocatedStockData () {
      return awbAllocatedStock.data || {}
    }
  }));

  if (validateStock) {
    let result;
    if (awbAllocatedStock && awbAllocatedStock.data) {
      if (Array.isArray(awbAllocatedStock.data) && awbAllocatedStock.data.length > 0) {
        const stock = awbAllocatedStock.data[0];
        if (stock.bookingUuid || stock.tripLegUuid)
          result = {isValid: false, message: "Airway Bill was already used and cannot be re-used on this booking"}
        else if (stock.companyUuid !== companyUuid) {
          result = {isValid: false, message: "Airway Bill is not allocated to ${}"}
        } else {
          result = {isValid: true, message: "Airway Bill is of valid stock allocation"}
        }
      } else {
        result = {isValid: false, message: "Airway Bill was not allocated to any client"}
      }
    }
    validateStock(result);
  }

  return ( <></> );
})

export default AwbAllocatedStockLookup;
